import React from 'react';
import PropTypes from 'prop-types';
import A11yFontIcon from 'components/A11yFontIcon';
import './FontIcon.css';

function FontIcon({ icon, className, title, alt, filled, disabled }) {
  const setClassName = `font-icon ${className || ''}${
    filled ? ' fa-highlight' : ''
  }${disabled ? ' fa-disabled' : ''}`;
  if (title === true) {
    title = alt;
  }
  return (
    <A11yFontIcon
      icon={icon}
      className={setClassName}
      title={title}
      alt={alt}
    />
  );
}

FontIcon.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
  title: PropTypes.string,
  alt: PropTypes.string.isRequired,
  filled: PropTypes.bool,
  disabled: PropTypes.bool
};

export default FontIcon;
